import * as React from "react";
import { api, DocumentDato } from "./helpers";
import { Icon } from "./Icon";


export function Document({ slug }) {

    const [document, setDocument] = React.useState<DocumentDato>();

    const handleDocument = async () => {
        const resp = await api.get_dato_document(slug);
        setDocument(resp.data.document);
    };

    React.useEffect(() => {
        handleDocument();
    }, []);

    const [openPreview, setOpenPreview] = React.useState(false);

    const hc = () => {
        setOpenPreview(!openPreview);
    };

    if (!document) {
        return <></>;
    }

    return <div className="container">
        <div><div className="title">{document.displayname} - {document.caption}</div><div onClick={hc} className="preview-button">Preview PDF <Icon size={"0.6"} icon={openPreview ? "chevron-down" : "chevron-right"} /></div></div>
        <div className="diagram-container">
            <div className="diagram">
                {openPreview ? <embed src={document.document.url} width="100%" height="375"
                    type="application/pdf" /> : null}
            </div>
            <small><strong>Download: </strong><a href={document.document.url} download>{document.displayname}</a></small>
        </div>
        <style jsx>
            {`
            .diagram {
                border-bottom: 1px solid var(--code-border);
            }            
            .diagram-container {
                margin-bottom: var(--default-vertical-spacing);
            }
            .preview-button {
                padding: 1rem;
                background: var(--code-background);
                font-size: var(--font-size-2);
                border-top: 1px solid var(--code-border);
            }
            .preview-button:hover {
                text-decoration: underline;
                cursor: pointer;
            }
            .container {
                border: 1px solid var(--code-border);
                margin-bottom: 1rem;
                width: 55rem;
                max-width: 100%;
            }
            .title {
                padding: 1rem;
                font-size: var(--font-size-3);
            }
            small {
                padding: 1rem 1rem 4px 1rem;
                display: block;
            }
            `}
        </style>
    </div>;

}
